import axios from "axios";

export const DEBUG = true;

export const STRIPE_KEY = "pk_test_51TJOuEDy6EBQtuB0rK1bsouzIcrxUfYezTKUGsTFVNe05PyFIWxxSzQRXcbH8FKMC0gnQIxbtfceNH0W1f8JT2r400JNL1IwqA";

export const CUSTOMER_ALLOWED_WAREHOUSES = [2];

export const AUTH_OBTAIN_ENDPOINT = "auth/";
export const AUTH_VERIFY_ENDPOINT = "verify/;";
export const AUTH_REFRESH_ENDPOINT = "auth/refresh/";
export const AUTH_CURRENT_USER_ENDPOINT = "currentuser/";
export const REGISTER_ENDPOINT = "register/";

export const API_URL = DEBUG
  ? "https://dev.fforders.com/api/"
  : "https://dev.fforders.com/api/";

export const backend = axios.create({ baseURL: API_URL });
